import { createContext, useContext, useState } from 'react';

const WalletStateContext = createContext();

export const WalletStateProvider = ({ children }) => {
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState(null);

  return (
    <WalletStateContext.Provider value={{
      isWalletConnected,
      setIsWalletConnected,
      walletAddress,
      setWalletAddress,
    }}>
      {children}
    </WalletStateContext.Provider>
  );
};

export const useWalletState = () => useContext(WalletStateContext);
